"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataLoaderGuard = dataLoaderGuard;
const app_1 = require("@kalkulacka-one/app");
const navigation_1 = require("next/navigation");
const clock_1 = require("../clock.js");
async function dataLoaderGuard({ endpoint, key, group }) {
    try {
        const calculatorData = await (0, app_1.loadCalculatorData)({ endpoint, key, group });
        return { ...calculatorData, now: (0, clock_1.now)().toISOString() };
    }
    catch (error) {
        if (error instanceof app_1.NotFoundError) {
            (0, navigation_1.notFound)();
        }
        throw error;
    }
}
